/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-state */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { replace } from "react-router-redux";
import { connect } from "react-redux";
import { compose } from "redux";
import { withNamespaces, Trans } from "react-i18next";
import { Field, reduxForm } from "redux-form";
import { BASE_URL } from "../../../../config/constants";
import BookingsToolbar from "../../components/BookingsToolbar";
import Form from "../../../../components/Form";
import Select from "../../../../components/Select";
import { required } from "../../../../services/validators";
import MultiSelect from "../../../../components/MultiSelect";
import {
  fetchLicencesManualBooking,
  fetchPartsManualBooking,
  clearParts,
  manualBooking
} from "../../Exams/Exams.ducks";
// Styles
import styles from "./ExaminationAssignment.css";
import Modal from "../../../../components/Modal";

class ExaminationAssignment extends Component {
  state = {
    confirmationModal: false,
    examinationParts: [],
    optionSelected: undefined,
    selectedLicenceId: undefined,
    selectedPartsDuration: 0,
    windowWidth: window.innerWidth
  };

  componentDidMount() {
    const { clearParts, fetchLicencesManualBooking } = this.props;
    clearParts();
    fetchLicencesManualBooking();
    window.addEventListener(`resize`, this.handleResize);
  }

  componentWillUnmount() {
    const { clearParts } = this.props;
    clearParts();
    this.setState({
      selectedLicenceId: undefined
    });
    window.removeEventListener(`resize`, this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  handleLicenceChange = (event) => {
    const { fetchPartsManualBooking, reset } = this.props;
    // reset the form to clear the selected parts (this reset is from the redux-form)
    reset();
    fetchPartsManualBooking(event.target.value);
    this.setState({
      selectedLicenceId: event.target.value
    });
  };

  return = () => {
    const { replace } = this.props;
    replace(`${BASE_URL}/dashboard/assign`);
  };

  handlePartsOptions = () => {
    const {
      exams: { parts }
    } = this.props;
    return parts.map((part) => ({ ...part, label: part.value }));
  };

  onChangeParts = (values) => {
    let examinationParts = [];
    let selectedPartsDuration = 0;
    Object.keys(values).forEach((value) => {
      if (values[value].duration) {
        selectedPartsDuration += values[value].duration;
        examinationParts.push(values[value].key);
      }
    });
    this.setState({ selectedPartsDuration, examinationParts });
  };

  getSelectedPartsTotalPrice = () => {
    const { examinationParts } = this.state;
    return examinationParts.reduce((acc, curr) => acc + +curr.price, 0);
  };

  handleNewBooking = () =>
    this.isExamFree() ? this.toggleConfirmationModal() : this.setState({ overlayOpen: true });

  handleScheduleManualBooking = () => {
    const {
      manualBooking,
      exams: { selectedSlots }
    } = this.props;
    const { examinationParts, selectedLicenceId } = this.state;

    manualBooking({
      examinationParts,
      date: selectedSlots.assignmentDate,
      licenceId: selectedLicenceId,
      locationId: selectedSlots.locationId,
      startTime: selectedSlots.startTime,
      stationId: selectedSlots.stationId
    });

    this.toggleConfirmationModal();
  };

  isExamFree = () => !this.getSelectedPartsTotalPrice();

  onEscape = ({ keyCode }) => {
    const { confirmationModal, overlayOpen } = this.state;

    if (keyCode === 27) {
      (overlayOpen || confirmationModal) &&
        this.setState({ confirmationModal: false, overlayOpen: false });
    }
  };

  toggleConfirmationModal = () => {
    this.setState((prevState) => ({
      confirmationModal: !prevState.confirmationModal
    }));
  };

  render() {
    const {
      handleSubmit,
      t,
      exams: {
        licences,
        selectedSlots: { availableMinutes }
      }
    } = this.props;
    const { selectedPartsDuration, examinationParts, windowWidth, confirmationModal } = this.state;
    const tabletMode = windowWidth < 1025;
    const partList = this.handlePartsOptions();

    return (
      <div className="container">
        <BookingsToolbar />
        <Form
          bootStrapClass="col-sm-12 well no-padding"
          buttonDisabled={Boolean(
            !examinationParts.length || selectedPartsDuration > availableMinutes
          )}
          buttonLeft
          buttonText={t(`modules.localization.register.generals.button.assign`)}
          handleSubmit={handleSubmit}
          onSubmit={this.toggleConfirmationModal}
          title={t(
            `modules.localization.register.authenticated.manualAssignment.assignExaminations`
          )}
          onBackButtonClick={this.return}
          backButtonText="Return"
          backButton={Boolean(true)}
        >
          <fieldset>
            <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <section className="col-md-10 col-lg-7">
                <Field
                  component={Select}
                  defaultValueLabel={t(
                    `modules.localization.register.authenticated.exams.pickLicence`
                  )}
                  errorMessage=" "
                  label={t(`modules.localization.register.authenticated.exams.licence`)}
                  name="licence"
                  onChange={this.handleLicenceChange}
                  options={licences}
                  validate={required}
                />
              </section>
            </div>
            {Boolean(partList.length) && (
              <>
                <Modal
                  cancelActionLabel={t(`modules.localization.register.generals.button.cancel`)}
                  closeModal={this.toggleConfirmationModal}
                  confirmAction={this.handleScheduleManualBooking}
                  confirmActionLabel={t(
                    `modules.localization.register.authenticated.exams.confirm`
                  )}
                  isOpen={confirmationModal}
                  title={t(`modules.localization.register.authenticated.exams.bookNow`)}
                >
                  <p>{t(`modules.localization.register.authenticated.exams.bookFreeExam`)}</p>
                </Modal>
                <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <section
                    className="col-md-10 col-lg-7"
                    style={tabletMode ? styles.partsSectionTablet : null}
                  >
                    <Field
                      component={MultiSelect}
                      errorMessage=" "
                      label={t(`modules.localization.register.authenticated.exams.parts`)}
                      allowSelectAll={Boolean(true)}
                      name="parts"
                      options={partList}
                      placeholder={t(`modules.localization.register.authenticated.exams.pickPart`)}
                      validate={required}
                      onChange={this.onChangeParts}
                    />
                  </section>
                  <section
                    className="col col-md-4 col-lg-4"
                    style={tabletMode ? styles.labelsSectionTablet : null}
                  >
                    <label
                      className="label"
                      style={{
                        ...(!tabletMode ? styles.labelTablet : null),
                        ...(selectedPartsDuration > availableMinutes ? styles.redLabel : null)
                      }}
                    >
                      <Trans
                        i18nKey="modules.localization.register.authenticated.manualAssignment.availableMinutes"
                        values={{
                          minutes: availableMinutes
                        }}
                      >
                        <b>
                          {t(
                            `modules.localization.register.authenticated.manualAssignment.availableMinutes`
                          )}
                        </b>
                      </Trans>
                    </label>
                    <label
                      className="label"
                      style={{
                        ...(selectedPartsDuration > availableMinutes ? styles.redLabel : null)
                      }}
                    >
                      <Trans
                        i18nKey="modules.localization.register.authenticated.manualAssignment.selectedPartsDuration"
                        values={{
                          duration: selectedPartsDuration
                        }}
                      >
                        <b>
                          {t(
                            `modules.localization.register.authenticated.manualAssignment.selectedPartsDuration`
                          )}
                        </b>
                      </Trans>
                    </label>
                  </section>
                </div>
              </>
            )}
          </fieldset>
        </Form>
      </div>
    );
  }
}

ExaminationAssignment.propTypes = {
  exams: PropTypes.object,
  fetchPartsManualBooking: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  clearParts: PropTypes.func.isRequired,
  fetchLicencesManualBooking: PropTypes.func.isRequired,
  manualBooking: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  clearParts,
  fetchLicencesManualBooking,
  fetchPartsManualBooking,
  replace,
  manualBooking
};

const mapStateToProps = (state) => ({
  exams: state.exams
});

export default compose(
  reduxForm({
    form: `assign-form`
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(ExaminationAssignment);
